import { Image as AntdImage, ImageProps as AntdImageProps } from 'antd';
import './style.css';

export interface ImageProps extends AntdImageProps {
  preview?: boolean;
  inChat?: boolean; 
}

const Image: React.FC<ImageProps> = ({ inChat, style, ...props }) => {
  const defaultStyle = inChat === false ? { width: '4rem' } : {};

  return (
    <AntdImage
      {...props}
      preview={props.preview ?? true}
      style={{ ...defaultStyle, ...style }} 
    />
  );
};

export default Image;